"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleVisibility = toggleVisibility;
exports.changePosition = changePosition;
exports.changeSize = changeSize;
exports.changeMonitor = changeMonitor;
exports.CHANGE_MONITOR = exports.CHANGE_SIZE = exports.CHANGE_POSITION = exports.TOGGLE_VISIBILITY = void 0;
var TOGGLE_VISIBILITY = '@@redux-devtools-log-monitor/TOGGLE_VISIBILITY';
exports.TOGGLE_VISIBILITY = TOGGLE_VISIBILITY;

function toggleVisibility() {
  return {
    type: TOGGLE_VISIBILITY
  };
}

var CHANGE_POSITION = '@@redux-devtools-log-monitor/CHANGE_POSITION';
exports.CHANGE_POSITION = CHANGE_POSITION;

function changePosition() {
  return {
    type: CHANGE_POSITION
  };
}

var CHANGE_SIZE = '@@redux-devtools-log-monitor/CHANGE_SIZE';
exports.CHANGE_SIZE = CHANGE_SIZE;

function changeSize(size) {
  return {
    type: CHANGE_SIZE,
    size: size
  };
}

var CHANGE_MONITOR = '@@redux-devtools-log-monitor/CHANGE_MONITOR';
exports.CHANGE_MONITOR = CHANGE_MONITOR;

function changeMonitor() {
  return {
    type: CHANGE_MONITOR
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/redux-devtools-dock-monitor/lib/actions.js
// module id = 626
// module chunks = 0